export default {
  name: 'MdmIcon',
  props: {
    name: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: '50'
    },
    width: {
      type: String,
      default: 'width'
    },
    height: {
      type: String,
      default: 'height'
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconName() {
      return "#".concat(this.name);
    },
    currentWidth() {
      return this.width !== 'width' ? this.width : this.size;
    },
    currentHeight() {
      return this.height !== 'height' ? this.height : this.size;
    },
    viewBox() {
      return "0 0 ".concat(this.currentWidth, " ").concat(this.currentHeight);
    }
  }
};